import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'sleep_quality'

export default function SleepQualityPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How would you rate your current sleep quality?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.sleepQuality.heading')}
      buttons={[
        {
          text: `😴 ${t('pages.onboarding.sleepQuality.options.excellent')}`,
          value: 'Excellent - I sleep like a baby',
          subtext: t('pages.onboarding.sleepQuality.subtexts.excellent'),
        },
        {
          text: `😌 ${t('pages.onboarding.sleepQuality.options.good')}`,
          value: 'Good - Usually restful',
          subtext: t('pages.onboarding.sleepQuality.subtexts.good'),
        },
        {
          text: `😐 ${t('pages.onboarding.sleepQuality.options.average')}`,
          value: 'Average - It varies',
          subtext: t('pages.onboarding.sleepQuality.subtexts.average'),
        },
        {
          text: `😫 ${t('pages.onboarding.sleepQuality.options.poor')}`,
          value: 'Poor - I struggle to rest well',
          subtext: t('pages.onboarding.sleepQuality.subtexts.poor'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
